module.exports = __webpack_public_path__ + "img/img-default-twu.34b56672.png";